













































import Vue from 'vue'
import dayjs from 'dayjs'
import { DATE_TIME_FORMAT } from '@/const'

import CommonArrow from '@/components/shared/atoms/Icon/CommonArrow'
import TrimmingImage from '@/components/shared/atoms/Image/TrimmingImage'
import Label from '@/components/shared/atoms/Label'

import EventEntity, { publishStatus } from '@/entities/Event'
import SchoolEntity from '@/entities/School'

export default Vue.extend({
  components: {
    CommonArrow,
    TrimmingImage,
    Label
  },
  props: {
    eventData: {
      type: Object as () => EventEntity,
      required: true
    },
    type: {
      type: String,
      default: ''
    },
    timestamp: {
      type: String,
      required: true
    },
    school: {
      type: Object as () => SchoolEntity,
      required: true
    },
    thumbnails: {
      type: Object as () => string[],
      default: null
    }
  },
  computed: {
    formatEventStartDt(): string {
      return dayjs(this.eventData.props.eventStartDt, DATE_TIME_FORMAT).format('YYYY年MM月DD日')
    },
    formatOrderEndDt(): string {
      return dayjs(this.eventData.props.orderEndDt, DATE_TIME_FORMAT).format('YYYY/MM/DD')
    },
    remainingDaysStr(): string {
      if (!this.timestamp) return ''
      const timestamp = dayjs(this.timestamp, DATE_TIME_FORMAT).format('YYYY-MM-DD 00:00:00.000000')
      if (this.eventData.getRemainingDays(timestamp) === 0) {
        return '本日まで'
      } else if (this.eventData.getRemainingDays(timestamp) < 0) {
        return 'まもなく'
      } else {
        return 'あと' + this.eventData.getRemainingDays(timestamp) + '日'
      }
    },
    remainingDays(): number | null {
      if (!this.timestamp) return null
      return this.eventData.getRemainingDays(this.timestamp)
    },
    isPasswordLocked(): boolean {
      return this.eventData.props.passwordType === 'none' || this.eventData.props.passwordUnlockFlag
    }
  },
  methods: {
    toEventPath() {
      if (this.eventData.props.publishStatus === 'waiting' || this.eventData.props.publishStatus === 'close') return
      this.$router.push({ path: '/events/' + this.eventData.props.id })
    },
    isStatus(status: publishStatus): boolean {
      return this.eventData.props.publishStatus === status
    }
  }
})
